module.exports = __webpack_public_path__ + "media/images/front/top/top_btn_1-6f53e1a0bc993bb54db69c1227fa7b86.svg";